import React, { Component } from "react";
import { t } from "i18next";
import { numberWithSpaces, withRouter } from "../../utils/GlobalFunctions";
import { Table, Popover, Statistic, Pagination, Input, Alert, Button } from "antd";
import { getBaseURL, getToken } from "../../utils/axiosRequest";
import { LoadingOutlined, PlusCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { isMobile } from "react-device-detect";
import moment from "moment";
const { Search } = Input;


export class PaymentList extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          isLoaded: false,
          data: null,
          requestFailed: false,
          errorMessage: null,
          errorDetails: null,
          userforms: null,
          pageSize: 20,
          currentPage: 1,
          searchValue: '',
          tableUpdate: false,
          position: getToken()?.position,
        };
    }

    componentDidMount() {
        this.getUserInvoices();
    }
    
    componentDidUpdate() {}

    getUserInvoices = ()=>{
        this.setState({ isLoaded: false, requestFailed: false, errorMessage: null });
        
        fetch(`${getBaseURL()}invoices/user`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + window.sessionStorage["access_token"],
            },
          })
          .then((response) => {
            if(response.status === 200){
                return response.json();     
            } else {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
          })
          .then((responseJson) => {
            this.setState({ 
              data: responseJson, 
              isLoaded: true, 
              requestFailed: false,
              errorMessage: null 
            });
          })
          .catch((error) => {
            console.error('Ошибка при загрузке счетов:', error);
            this.setState({ 
              isLoaded: true, 
              requestFailed: true,
              errorMessage: error.message || 'Произошла ошибка при загрузке данных',
              errorDetails: {
                error: error.message,
                stack: error.stack,
                url: `${getBaseURL()}invoices/user`,
                timestamp: new Date().toISOString(),
                userAgent: navigator.userAgent,
                userId: getToken()?.id || 'unknown'
              }
            });
          }); 
    }

    onHandlePageChange = (page, size) => {
        this.setState({currentPage: page, pageSize: size, tableUpdate: true});
       
        fetch(`${getBaseURL()}invoices/user?skip=${(page-1)*size}&limit=${size}&q=${this.state.searchValue}`, 
        {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + window.sessionStorage["access_token"],
            },
          })
          .then((response) => {
            if(response.status === 200){
                return response.json();     
            } else {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
          })
          .then((responseJson) => {
            this.setState({ 
              data: responseJson, 
              isLoaded: true, 
              tableUpdate: false,
              requestFailed: false,
              errorMessage: null 
            });
          })
          .catch((error) => {
            console.error('Ошибка при загрузке страницы:', error);
            this.setState({ 
              isLoaded: true, 
              tableUpdate: false,
              requestFailed: true,
              errorMessage: error.message || 'Произошла ошибка при загрузке данных',
              errorDetails: {
                error: error.message,
                stack: error.stack,
                url: `${getBaseURL()}invoices/user?skip=${(page-1)*size}&limit=${size}&q=${this.state.searchValue}`,
                timestamp: new Date().toISOString(),
                userAgent: navigator.userAgent,
                userId: getToken()?.id || 'unknown'
              }
            });
          });
    };

    onSearchValueChange = (value) => {
      this.setState({searchValue: value});
    };
  
    onInvoiceSearch = (value) => {
      this.setState({searchValue: value});
      this.onHandlePageChange( this.state.currentPage, this.state.pageSize);
    };

    sendErrorToSupport = () => {
      const { errorDetails } = this.state;
      
      if (!errorDetails) {
        console.error('Нет деталей ошибки для отправки');
        return;
      }

      fetch(`${getBaseURL()}common/frontend_errors`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.sessionStorage["access_token"],
        },
        body: JSON.stringify({
          details: errorDetails
        })
      })
      .then((response) => {
        if (response.ok) {
          alert('Ошибка успешно отправлена в тех.поддержку');
        } else {
          console.error('Ошибка при отправке отчета:', response.status);
          alert('Не удалось отправить ошибку в тех.поддержку');
        }
      })
      .catch((error) => {
        console.error('Ошибка при отправке отчета:', error);
        alert('Не удалось отправить ошибку в тех.поддержку');
      });
    };

render() {
    const {isLoaded, data, currentPage, pageSize, searchValue, requestFailed, errorMessage} = this.state;
    const {translation} = this.props;
    const columns = [
        {
          title: "№ Ҳисобнома",
          dataIndex: "invoice_number",
          width: "8%",
          key: "invoice_number",
          //...getColumnSearchProps('invoice_number', t('INVOICE_NUMBER').toLowerCase()),
          render: (invoice_number, row) => {
            return (<Link to={`/payments/${row.status==='open' && row.contract ?'cs':'invoice'}/${invoice_number}`} state={{status: row.status}} >
                    <div className="text-[12px]">{numberWithSpaces(invoice_number)}</div>
                </Link>
            );
          },
        },

        {
          title: "№ Дархост",
          dataIndex: "order_id",
          width: "6%",
          key: "order_id",
          //...getColumnSearchProps('invoice_number', t('INVOICE_NUMBER').toLowerCase()),
          render: (order_id, row) => {
            return (<div className="text-[12px]">{order_id}</div>
                
            );
          },
        },

        {
          title: t("DATE"),
          dataIndex: "create_at",
          key: "create_at",
          width: "8%",
          align: "center",
          render: (create_at, row) => {
            return (
                <Link to={`/payments/${row.status==='open' && row.contract ?'cs':'invoice'}/${row.invoice_number}`} state={{status: row.status}} >
                    <div className="text-[10px]">{moment(create_at).format("DD.MM.YYYY  HH:mm")}</div>
                </Link>
            );
          },
        },
        
        {
          title: t("AMOUNT"),
          align: "center",
    
          children: [
            {
              title: "Пардохт-шуда",
              width: "6%",
              dataIndex: "amount_paid",
              key: "amount_paid",
              render: (amount_paid, row) => {
                return (
                <Link to={`/payments/${row.status==='open' && row.contract ?'cs':'invoice'}/${row.invoice_number}`} state={{status: row.status}} >
                  <div className="text-right text-[12px] text-emerald-500">
                    {amount_paid !== 0 ? (
                      numberWithSpaces((amount_paid / 100).toFixed(2))
                    ) : (
                      <></>
                    )}
                  </div>
                </Link>
                );
              },
            },
            {
              title: "Пардохт-нашуда",
              width: "6%",
              dataIndex: "amount_unpaid",
              key: "amount_unpaid",
              render: (amount_unpaid, row) => {
                return (
                <Link to={`/payments/${row.status==='open' && row.contract ?'cs':'invoice'}/${row.invoice_number}`} state={{status: row.status}} >
                  <div className="text-right text-[12px] text-[red]">
                    {amount_unpaid !== 0 ? (
                      numberWithSpaces((amount_unpaid / 100).toFixed(2))
                    ) : (
                      <></>
                    )}
                  </div>
                </Link>
                );
              },
            },
          ],
        },
    
        {
          title: t("SERVICES"),
          width: "15%",
          dataIndex: "subject",
          key: "subject",
          className: "",
          //...getColumnSearchProps('subject', t('SERVICES').toLowerCase()),
          render: (subject, row) => {
            return (
              <Popover
                overlayStyle={{ maxWidth: "400px" }}
                content={subject}
                title={t("GOV_SERVICE")}
                trigger="hover"
              >
                <Link to={`/payments/${row.status==='open' && row.contract ?'cs':'invoice'}/${row.invoice_number}`} state={{status: row.status}} >
                <p className="mline-clamp">{subject}</p>
                </Link>
              </Popover>
            );
          },
        },
    
        {
          title: t("PAYER"),
          dataIndex: "fullName",
          width: "15%",
          key: "fullName",
          //...getColumnSearchProps('fullName', t('PAYER').toLowerCase()),
          render: (fullName, row) => {
            return (
                <Link to={`/payments/${row.status==='open' && row.contract ?'cs':'invoice'}/${row.invoice_number}`} state={{status: row.status}} >
                <div className="uppercase text-[12px]">{fullName}</div>
                </Link>
            );
          },
        },
    
        
    
        /*{
          title: t("PERFORMER"),
          dataIndex: "create_by",
          key: "create_by",
          //...getColumnSearchProps('create_by', t('PERFORMER').toLowerCase()),
          render: (create_by, row) => {
            
            return (
                <Link to={`/payments/invoice/${row.invoice_number}`} state={{status: row.status}} >
                <div className={`${row.amount_unpaid === 0 ? 'text-green-500' : 'text-red-500'} text-[12px]`}>{create_by}</div>
              </Link>
            );
          },
        },*/
      ];

return (
<div className="w-full">
    {!isLoaded && !requestFailed ? (
        <div className="w-full flex justify-center">
            <LoadingOutlined style={{ fontSize: 24, }} spin />
        </div>
    ) : requestFailed ? (
        <div className="w-full p-4">
            <Alert
                message="Ошибка загрузки данных"
                description={errorMessage || "Произошла ошибка при загрузке счетов. Пожалуйста, попробуйте еще раз."}
                type="error"
                showIcon
                action={
                    <Button 
                        size="small" 
                        danger 
                        onClick={this.sendErrorToSupport}
                        icon={<ReloadOutlined />}
                    >
                        Отправить ошибку в тех.поддержку
                    </Button>
                }
            />
        </div>
    ) : (
        <div className="w-full">
        <div className="w-full sm:hidden lg:flex xl:flex justify-between px-4">
            <div className="w-[22%] bg-white drop-shadow-xl rounded-xl text-center my-2">
            
              
            </div>
            
        </div>
        <div className="mt-4">
            <div className="m-2 flex justify-between">
            {this.state.position === 'supervisor' ? <>  
            <Link to ='/payments/forms' className="flex bg-emerald-600 mr-[2rem] text-white m-2 lg:text-md xl:text-lg sm:px-3 sm:py-1 md:px-3 lg:px-5 xl:px-10 md:py-1 lg:py-1 xl:py-1 whitespace-nowrap rounded-[8px]">
              <div className="flex items-center">
                <div className="flex mr-4 items-center">
                  <PlusCircleOutlined color="#fff" />
                </div>
                <div>{t("CREATE_INVOICE")}</div>
              </div>
            </Link>
            </> : <></>}
            <Search
                className="p-4"
                id="searchInvoice"
                allowClear
                onChange={(e)=>this.onSearchValueChange(e.target.value)}
                placeholder={t("INVOICE_SEARCH")}
                onSearch={this.onInvoiceSearch}
                value={searchValue}
                enterButton
            />
            
            </div>

            
            {this.state.tableUpdate ? <>
                <div className="w-full h-[10rem] flex items-center justify-center"><LoadingOutlined style={{ fontSize: 24, }} spin /></div>
            </>
            
            :<> <Table 
                className="md:pl-4"
                dataSource={data.invoices ? data.invoices : null}
                columns={columns} 
                pagination={false} 
                sticky
                size="small"
            >
            </Table>
            <Pagination
                className="mt-[2rem] ml-4"
                onChange={this.onHandlePageChange}
                onShowSizeChange={this.onHandlePageChange}
                total={data.stats ? Math.ceil(data.stats.open_qty + data.stats.charged_qty) : 0}
                current={currentPage}
                pageSize={pageSize}
                hideOnSinglePage={true}
              />
            </>
            }
            
        </div>
    </div>
    )}
</div>
)
}

}

export default withRouter(PaymentList);